var render = function render(){var _vm=this,_c=_vm._self._c;return _c('HubRules',{attrs:{"html":_vm.html}})
}
var staticRenderFns = []

export { render, staticRenderFns }